import { EGameKey } from "MVVM/@types";

export const gameIdToKey = (gameId: unknown): EGameKey => {
  switch (gameId) {
    case 730:
      return EGameKey.CS_GO;
    case 7302:
      return EGameKey.CS2;
    case 570:
      return EGameKey.DOTA2;
    case 407:
      return EGameKey.FORTNITE;
    case 101:
      return EGameKey.LOL;
    case 2357570:
      return EGameKey.OW2;
    default:
      return EGameKey.UNKNOWN;
  }
};
